var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { createMedias } from './reduxMedias';
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
const initialState = {
    data: [],
    loading: false,
    count: 0,
};
export const createTakeRefMedia = createAsyncThunk('reduxTakeRefMedias/create', (refMedias_1, _a) => __awaiter(void 0, [refMedias_1, _a], void 0, function* (refMedias, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        if (refMedias.length > 1) {
            const promises = refMedias.flatMap((val) => __awaiter(void 0, void 0, void 0, function* () {
                const medias = val.medias;
                const { payload } = yield dispatch(createMedias(medias));
                return payload;
            }));
            const mediasResponse = yield Promise.all(promises);
            const relations = mediasResponse.flatMap((media, i) => {
                const relation = media.map((r) => {
                    return { media: r.id, take: refMedias[i].take };
                });
                return relation;
            });
            const res = yield api.takeRefMedias.collection.create(relations);
            return fulfillWithValue(res);
        }
        const medias = refMedias.flatMap((el) => el.medias);
        const take = refMedias[0].take;
        const { payload } = yield dispatch(createMedias(medias));
        const relations = payload.map((el) => ({ media: el.id, take }));
        const res = yield api.takeRefMedias.collection.create(relations);
        return fulfillWithValue(res);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxTakeRefMedias',
    initialState,
    reducers: {
        createTakeRefMediasFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (flag) => flag.id);
            state.data = newData;
        },
        deleteTakeRefMediasFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = [...state.data].filter((flag) => flag.id !== updatedPayload.id);
            state.data = newData;
        },
        setAllTakeRefMedias: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(createTakeRefMedia.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        });
    },
});
export const { createTakeRefMediasFromWS, deleteTakeRefMediasFromWS, setAllTakeRefMedias } = actions;
export default reducer;
